import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-history',
    templateUrl: './history.component.html',
    styleUrls: ['./history.component.scss'],
    standalone: false
})
export class HistoryComponent implements OnInit {
  @Input() updatedAt: string;
  @Input() updatedBy: string;

  constructor() { }

  ngOnInit() {
  }

}
